module.exports = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/an-instance.js